
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.666","height":"19.634"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Tracé 6723","d":"M18.179 19.634H3.487a3.41 3.41 0 01-3.142-1.469 3.41 3.41 0 01.3-3.456L7.991 1.986A3.409 3.409 0 0110.833 0a3.409 3.409 0 012.843 1.986l7.346 12.723a3.41 3.41 0 01.3 3.456 3.409 3.409 0 01-3.143 1.469zm-5.847-4.478a1.383 1.383 0 10-1.383 1.383 1.383 1.383 0 001.383-1.383zm.037-8.321a1.42 1.42 0 10-2.84 0l.335 5.039a1.087 1.087 0 002.147.125 1.116 1.116 0 00.013-.125h.01z","fill":"#c22234"}})])
          )
        }
      }
    